import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './core/auth/auth.service';
import { filter, first, takeUntil, tap } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Patient Association Application Cloud';
  brandName = '';
  brandLogo = '';
  canAccessApp: boolean = false;
  errorHeader = '';
  errorMessage = '';
  canActivateProtectedRoutes$: Observable<boolean>;

  private _destroy$ = new Subject<void>();

  constructor(
    private readonly modalService: NgbModal,
    private authService: AuthService,
    private router: Router

  ) {
    this.canActivateProtectedRoutes$ = this.authService.canActivateProtectedRoutes$;
    this.authService.runInitialLoginSequence();
  }

  ngOnInit() {
    this.canActivateProtectedRoutes$
      .pipe(
        takeUntil(this._destroy$),
        first(ready => ready === true),
        tap(ready => {
          this.brandName = 'Patient Association Application Cloud';
          this.brandLogo = 'assets/images/logo/logo.png';
          this.canAccessApp = true;
        }),
      ).subscribe();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.id === 1 && event.url ==="/clinician/patient-device-detail") {
        this.router.navigate(['/clinician']);
      }
    });
  }

  ngOnDestroy() {
    this.canAccessApp = false;
    this._destroy$.next();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(): void {
    this.canAccessApp = false;
  }

  /**
   * Listen to browser back button
   * Close all modals if opened
   */
  @HostListener('window:popstate', ['$event']) popState($event: any): void {
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll();
    }
  }

}
